import AdwiredNewsWidget from './AdwiredNewsWidget';

export default AdwiredNewsWidget;
